(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const desktop = window.matchMedia('(min-width: 750px)');
    const sync = () => {
      for (const column of document.querySelectorAll('[data-footer-column]')) {
        column.open = desktop.matches;
      }
    };
    sync();
    desktop.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    #index = 0;
    #timer = null;
    #paused = false;
    #userPaused = false;

    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.bars = [...this.querySelectorAll('[data-go]')];
      this.current = this.querySelector('[data-current]');
      this.pauseButton = this.querySelector('[data-pause]');
      this.speed = Number(this.dataset.speed) || 6000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduce;
      if (!this.autoplay) this.classList.add('is-paused');

      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-label', `${i + 1} / ${this.slides.length}`);
      });

      for (const bar of this.bars) {
        bar.addEventListener('click', () => this.go(Number(bar.dataset.go), true));
      }

      this.pauseButton?.addEventListener('click', () => {
        this.#userPaused = !this.#userPaused;
        this.#setPaused(this.#userPaused);
      });

      this.addEventListener('mouseenter', () => this.#setPaused(true));
      this.addEventListener('mouseleave', () => { if (!this.#userPaused) this.#setPaused(false); });
      this.addEventListener('focusin', () => this.#setPaused(true));
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget) && !this.#userPaused) this.#setPaused(false); });

      // Touch swipe
      let startX = null;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        const rtl = document.documentElement.dir === 'rtl';
        const forward = rtl ? dx > 0 : dx < 0;
        this.go(this.#index + (forward ? 1 : -1), true);
      });

      document.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
        if (i > -1) { this.#userPaused = true; this.#setPaused(true); this.go(i); }
      });

      this.#schedule();
    }

    disconnectedCallback() {
      clearTimeout(this.#timer);
    }

    go(target, fromUser = false) {
      const count = this.slides.length;
      const next = (target + count) % count;
      if (next === this.#index && !fromUser) return;
      const prev = this.#index;
      this.#index = next;

      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('aria-hidden', !active);
        for (const el of slide.querySelectorAll('a, button')) {
          if (active) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
        }
      });

      this.bars.forEach((bar, i) => {
        bar.classList.toggle('is-active', i === next);
        bar.classList.toggle('is-done', i < next);
        if (i === next) bar.setAttribute('aria-current', 'true'); else bar.removeAttribute('aria-current');
        // restart progress animation
        const fill = bar.querySelector('.hero__bar-fill');
        if (fill && i === next) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
      });

      if (this.current) this.current.textContent = String(next + 1).padStart(2, '0');
      if (fromUser) this.querySelector('[data-slides]')?.setAttribute('aria-live', 'polite');
      if (prev !== next) this.#schedule();
    }

    #setPaused(paused) {
      this.#paused = paused;
      this.classList.toggle('is-paused', paused || !this.autoplay);
      if (this.pauseButton) {
        this.pauseButton.setAttribute('aria-pressed', String(this.#userPaused));
        this.pauseButton.setAttribute('aria-label', this.#userPaused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause);
      }
      this.#schedule();
    }

    #schedule() {
      clearTimeout(this.#timer);
      if (!this.autoplay || this.#paused) return;
      this.#timer = setTimeout(() => this.go(this.#index + 1), this.speed);
    }
  }

  if (!customElements.get('hero-slideshow')) customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const items = new Set();
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      for (const media of items) {
        const img = media.querySelector('img');
        if (!img) continue;
        const rect = media.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) continue;
        const progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
        img.style.transform = `translate3d(0, ${(progress * 40).toFixed(1)}px, 0)`;
      }
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    const collect = () => {
      for (const media of document.querySelectorAll('[data-parallax]')) items.add(media);
      update();
    };
    collect();
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', collect);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.dots = [...this.querySelectorAll('.gallery__dot')];
      this.counter = this.querySelector('[data-counter]');
      this.track = this.querySelector('[data-track]');
      this.desktop = window.matchMedia('(min-width: 750px)');

      for (const thumb of this.thumbs) {
        thumb.addEventListener('click', () => this.show(Number(thumb.dataset.thumb)));
      }

      let ticking = false;
      this.track?.addEventListener('scroll', () => {
        if (this.desktop.matches || ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const width = this.track.clientWidth || 1;
          const index = Math.round(Math.abs(this.track.scrollLeft) / width);
          this.#mark(index);
        });
      }, { passive: true });
    }

    /** @param {number} index */
    show(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.#mark(index);
      if (!this.desktop.matches && this.track) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.slides[index].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    /** @param {string|number} mediaId */
    showMedia(mediaId) {
      const index = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (index > -1) this.show(index);
    }

    /** @param {number} index */
    #mark(index) {
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      this.thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      if (this.counter) this.counter.textContent = String(index + 1);
    }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  class ProductForm extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-product-json]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.idInput = this.querySelector('[data-variant-id]');
      this.button = this.querySelector('[data-add-button]');
      this.label = this.querySelector('[data-add-label]');
      this.section = this.closest('[data-product-section]');
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-position]')) this.#onOptionChange();
      });
    }

    #selectedOptions() {
      const positions = [...new Set([...this.querySelectorAll('[data-option-position]')].map((i) => i.dataset.optionPosition))];
      return positions.map((p) => this.querySelector(`[data-option-position="${p}"]:checked`)?.value);
    }

    async #onOptionChange() {
      const selected = this.#selectedOptions();
      const variant = this.variants.find((v) => v.options.every((o, i) => o === selected[i]));
      const strings = window.FBC?.strings || {};

      if (!variant) {
        this.button.disabled = true;
        this.label.textContent = strings.unavailable;
        return;
      }

      this.idInput.value = String(variant.id);
      this.button.disabled = !variant.available;
      this.label.textContent = variant.available ? strings.addToBag : strings.soldOut;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      history.replaceState({}, '', url.toString());

      if (variant.featured_media) this.section?.querySelector('product-gallery')?.showMedia(variant.featured_media.id);

      // Refresh price and size from the server so formatting matches Liquid exactly
      try {
        const fetchUrl = new URL(this.dataset.productUrl, window.location.origin);
        fetchUrl.searchParams.set('variant', String(variant.id));
        fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
        const html = await (await fetch(fetchUrl)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        for (const selector of ['[data-price]', '[data-size-row]', '[data-sku]']) {
          const fresh = doc.querySelector(selector);
          const current = this.section?.querySelector(selector);
          if (fresh && current) current.replaceWith(fresh);
        }
      } catch {
        /* keep current price on network error */
      }
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
  class WishlistPage extends HTMLElement {
    async connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.status = this.querySelector('[data-wishlist-status]');
      document.addEventListener('wishlist:change', (event) => this.#prune(event.detail.handles));
      await this.#load();
    }

    async #load() {
      // global.js is deferred; wait for it if this script ran first
      if (!window.FBC?.wishlist && document.readyState === 'loading') {
        await new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
      }
      const wishlist = window.FBC?.wishlist;
      if (!wishlist) return;
      const handles = wishlist.read();
      if (!handles.length) { this.#showEmpty(); return; }
      this.status.textContent = window.FBC.strings.loading;

      const results = await Promise.all(handles.map(async (handle) => {
        try {
          const url = new URL(wishlist.localUrl(`products/${encodeURIComponent(handle)}`), window.location.origin);
          url.searchParams.set('section_id', 'product-card-ajax');
          const response = await fetch(url);
          if (!response.ok) return { handle, html: null, missing: response.status === 404 };
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          return { handle, html: doc.querySelector('[data-ajax-card]')?.innerHTML || null, missing: false };
        } catch {
          return { handle, html: null, missing: false };
        }
      }));

      const missing = results.filter((r) => r.missing).map((r) => r.handle);
      if (missing.length) wishlist.write(handles.filter((h) => !missing.includes(h)));

      for (const { handle, html } of results) {
        if (!html) continue;
        const li = document.createElement('li');
        li.dataset.handle = handle;
        li.innerHTML = html;
        this.grid.append(li);
      }
      this.#updateStatus();
      window.FBC.observeReveal?.(this.grid);
      wishlist.sync();
    }

    /** @param {string[]} handles */
    #prune(handles) {
      for (const li of this.grid.querySelectorAll('li[data-handle]')) {
        if (!handles.includes(li.dataset.handle)) li.remove();
      }
      this.#updateStatus();
    }

    #updateStatus() {
      const count = this.grid.children.length;
      if (!count) { this.#showEmpty(); return; }
      this.status.textContent = window.FBC.strings.wishlistCount.replace('[count]', String(count));
    }

    #showEmpty() {
      this.status.textContent = '';
      this.empty.hidden = false;
    }
  }
  if (!customElements.get('wishlist-page')) customElements.define('wishlist-page', WishlistPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.grid')) return;
      const load = async () => {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = doc.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) {
            this.innerHTML = fresh.innerHTML;
            window.FBC?.observeReveal?.(this);
            window.FBC?.wishlist?.sync?.();
          }
        } catch {
          /* recommendations are optional */
        }
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        load();
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visit-us"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observe = () => {
      const items = document.querySelectorAll('[data-clip-reveal]:not(.is-revealed)');
      if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
        for (const el of items) el.classList.add('is-revealed');
        return;
      }
      const io = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      }, { threshold: 0.2 });
      for (const el of items) io.observe(el);
    };
    observe();
    document.addEventListener('shopify:section:load', observe);
  })();

  } catch(e) { console.error(e); }
})();
})();
